module.exports = __webpack_public_path__ + "img/serve6.d4657bbd.png";